import React from "react";
import map from "../../assets/map.webp";
import cgmap from "../../assets/cgmap.webp";

const CGFirst = () => {
  return (
    <div className="relative md:mt-0 mt-20 w-full overflow-hidden">
      {/* World Map Background */}
      <img src={map} alt="World Map" className="absolute inset-0 opacity-60" />

      {/* Main Content Container */}
      <div className="container mx-auto pt-20 flex flex-col items-center">
        {/* Header */}
        <h2 className="text-3xl md:text-5xl font-bold mb-4 text-center text-white">
          Chhattisgarh's First Premier Data Center
        </h2>
        <br />
        <div className="flex flex-col md:flex-row items-center justify-between gap-12 w-full">
          {/* Left Side - Chhattisgarh Map */}
          <div className="w-full md:w-1/2 relative">
            <div className="relative">
              <img
                src={cgmap}
                alt="Chhattisgarh Map"
                className="w-full relative"
              />
            </div>
          </div>

          {/* Right Side - Content */}
          <div className="w-full md:w-1/2 text-white">
            <div className="mb-8">
              <h3 className="text-4xl md:text-6xl font-bold mb-4 text-center md:text-left">
                #1
                <span className="text-white text-3xl md:text-4xl ml-3">
                  in Chhattisgarh
                </span>
              </h3>
            </div>

            <p className="text-md md:text-lg text-gray-300  leading-relaxed text-center md:text-left">
              At <b className="text-white">Multify</b>, we are pioneering the
              future of data management and IT services in Chhattisgarh,
              offering state-of-the-art solutions to businesses seeking
              reliable, secure, and scalable infrastructure. As the region's
              first data center, we are committed to delivering excellence
              through innovation, technology, and unmatched customer service.
            </p>
            <br />
            <p className="text-md md:text-lg text-gray-300  leading-relaxed text-center md:text-left">
              Multify offers AI-powered IT services and infrastructure,
              including cloud computing, disaster recovery, and data backup,
              from its state-of-the-art, secure data center. They leverage AI
              and machine learning to enhance efficiency and agility, provide
              scalable solutions, and offer 24/7 support. As Chhattisgarh's
              first data center, Multify aims to lead the region's digital
              transformation.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CGFirst;
